// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2XiQw","selects":"Documents_selects__2WE65"};